import { apiSlice } from "./api";

interface DownloadGuestsRequest {
  ventId: string;
  guestIds: string[];
}
interface DownloadGuestsResponse {
  filename: string;
}

interface DownloadCalendarRequest {
  ventId: string;
}
interface DownloadCalendarResponse {}

// Extend the endpoints
export const downloadsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    downloadGuests: builder.mutation<
      DownloadGuestsResponse,
      DownloadGuestsRequest
    >({
      query: (body) => ({
        url: "downloadGuests", // The new API endpoint URL on your Go server
        method: "POST",
        body: JSON.stringify(body),
        // Crucially, tell RTK Query to expect a blob response
        responseHandler: async (response): Promise<DownloadGuestsResponse> => {
          let objectUrl: string | null = null; // Variable to hold the object URL for cleanup
          if (response.ok) {
            const disposition = response.headers.get("content-disposition");
            let filename = "download.csv"; // Default filename
            if (disposition && disposition.indexOf("attachment") !== -1) {
              const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              const matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                // Decode URI component and remove quotes
                filename = decodeURIComponent(matches[1].replace(/['"]/g, ""));
              }
            }
            // Return the blob data and filename
            const blob = await response.blob();
            objectUrl = URL.createObjectURL(blob);
            const anchor = document.createElement("a");
            anchor.href = objectUrl;
            anchor.download = filename;
            // Append to body (required for Firefox)
            document.body.appendChild(anchor);
            anchor.click();
            anchor.remove();
            return { filename }; // Return object matching DownloadGuestsResponse
          }
          // Handle errors - attempt to parse error response as JSON
          try {
            const errorJson = await response.json();
            throw new Error(errorJson.message || "Failed to download CSV");
          } catch (e) {
            // If parsing JSON fails, throw a generic error
            throw new Error(`Failed to download CSV: ${response.statusText}`);
          } finally {
            if (objectUrl) {
              URL.revokeObjectURL(objectUrl);
            }
          }
        },
      }),
    }),
    //
    downloadCalendar: builder.mutation<
      DownloadCalendarResponse,
      DownloadCalendarRequest
    >({
      query: (body) => ({
        url: "downloadCalendar",
        method: "POST",
        body: JSON.stringify(body),
        // Crucially, tell RTK Query to expect a blob response
        responseHandler: async (
          response
        ): Promise<DownloadCalendarResponse> => {
          let objectUrl: string | null = null; // Variable to hold the object URL for cleanup
          if (response.ok) {
            const disposition = response.headers.get("content-disposition");
            let filename = "download.ics"; // Default filename
            if (disposition && disposition.indexOf("attachment") !== -1) {
              const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              const matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                // Decode URI component and remove quotes
                filename = decodeURIComponent(matches[1].replace(/['"]/g, ""));
              }
            }
            // Return the blob data and filename
            const blob = await response.blob();
            objectUrl = URL.createObjectURL(blob);
            const anchor = document.createElement("a");
            anchor.href = objectUrl;
            anchor.download = filename;
            // Append to body (required for Firefox)
            document.body.appendChild(anchor);
            anchor.click();
            anchor.remove();
            return { filename }; // Return object matching DownloadGuestsResponse
          }
          // Handle errors - attempt to parse error response as JSON
          try {
            const errorJson = await response.json();
            throw new Error(
              errorJson.message || "Failed to download calendar file"
            );
          } catch (e) {
            // If parsing JSON fails, throw a generic error
            throw new Error(
              `Failed to download calendar file: ${response.statusText}`
            );
          } finally {
            if (objectUrl) {
              URL.revokeObjectURL(objectUrl);
            }
          }
        },
      }),
    }),
    //
  }),
  // Keep existing endpoints
  overrideExisting: false,
});

// Export the hook for use in components
export const { useDownloadGuestsMutation, useDownloadCalendarMutation } =
  downloadsApi;
